/**
 * Identité affichée — une seule fonction pour tout le studio (coquille.md §6.1).
 *
 * Le nom affiché est TOUJOURS un nom lisible, jamais l'email. Ordre de résolution : nom
 * d'affichage du produit, puis nom du compte d'identité, puis partie locale de l'email.
 *
 * Les initiales se calculent sur la première lettre du PREMIER et du DERNIER mot, coupé
 * sur espaces, points, tirets et soulignés. « Cédric Koch » → CK, « c.koch » → CK,
 * « Développeur local » → DL, « Ada » → A.
 */

export function nomAffiche(user) {
  if (!user) return '';
  const nom = (user.displayName || user.name || '').trim();
  if (nom) return nom;
  const email = user.email || '';
  return email.includes('@') ? email.slice(0, email.indexOf('@')) : email;
}

export function initiales(nom) {
  const mots = String(nom || '')
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (mots.length === 0) return '';
  const premier = mots[0][0];
  const dernier = mots.length > 1 ? mots[mots.length - 1][0] : '';
  return (premier + dernier).toUpperCase();
}
